import CustomSelectMenu from "@components/FormFields/CustomSelectMenu";
import { useDialog } from "@hooks/useDialog";
import { ScreenWithPlayingInfo, useScreens } from "@hooks/useScreens";
import { useMusicZone } from "@utils/queries";
import { MdEdit } from "react-icons/md";

export function EditMusicStatus({ screen }: { screen: ScreenWithPlayingInfo }) {
    const { openDialog, showSuccessSnackbar, showErrorSnackbar, closeDialog } = useDialog();
    const { updateScreen } = useScreens();
    const editMusicZone = useMusicZone.edit();

    const openEditDialog = () => {
        openDialog({
            title: "Edit Music Status",
            customContent: (
                <div className="flex flex-col gap-4 pt-2">
                    <CustomSelectMenu
                        label="Status"
                        options={['active', 'demo'] as const}
                        selected={screen.music_status}
                        optionRender={(val) => val}
                        selectedRender={(val) => val}
                        onChange={async (m) => {
                            if (!m || !screen.zone_id) return
                            closeDialog();
                            try {
                                await editMusicZone.mutateAsync({
                                    id: screen.zone_id,
                                    name: screen.name ?? "NA",
                                    status: m
                                });
                                updateScreen({
                                    screenId: screen.id,
                                    data: {
                                        name: screen.name ?? "",
                                        music_status: m
                                    }
                                });

                                showSuccessSnackbar("Music status updated successfully");
                            } catch (error) {
                                showErrorSnackbar("Failed to update music status");
                            }
                        }}
                    />
                </div>
            ),
        });
    };

    return (
        <button
            onClick={openEditDialog}
            className="group/edit flex items-center rounded-full bg-primary/10 px-4 py-2 hover:bg-primary/20 transition-colors relative"
        >
            <span className="text-xs text-primary capitalize">
                {screen.music_status || '-'}
            </span>
            <div className="overflow-hidden w-0 group-hover/edit:w-6 transition-[width] duration-200">
                <MdEdit className="h-4 w-4 ml-2 text-primary opacity-0 group-hover/edit:opacity-100 transition-opacity" />
            </div>
        </button>
    );
}